
import { defineComponent } from 'vue'
import Card from 'primevue/card'
import RegistryFilterCard from './RegistryFilterCard.vue'
import registryDescriptor from './RegistryDescriptor.json'

export default defineComponent({
    name: 'registry-filters-card',
    components: { Card, RegistryFilterCard },
    props: {
        propFilters: { type: Array },
        entity: { type: String },
        id: { type: String }
    },
    emits: ['filter'],
    data() {
        return {
            registryDescriptor,
            filters: [] as any[],
            clearFiltersTrigger: false,
            filterButtonDisabled: false
        }
    },
    watch: {
        propFilters() {
            this.loadFilters()
        }
    },
    async created() {
        this.loadFilters()
    },
    methods: {
        loadFilters() {
            this.filters = this.propFilters ? this.propFilters.filter((filter: any) => filter.visible) : []
        },
        setFilterValue(value: string, index: number) {
            this.filters[index].filterValue = value
        },
        clearAllFilters() {
            this.filters.forEach((el: any) => (el.filterValue = ''))
            this.clearFiltersTrigger = !this.clearFiltersTrigger
            this.$emit('filter', this.filters)
        },
        filterRegistry() {
            this.$emit('filter', this.filters)
        },
        setFilterButtonDisabled(valid) {
            this.filterButtonDisabled = !valid
        }
    }
})
